var _path, _path2, _path3, _rect, _circle, _text, _circle2, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyCommodity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 30 L16 24 L24 30 L16 36 Z",
    fill: "#C9A227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 36 L24 30 L24 38 L16 44 Z",
    fill: "#E8D38A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 36 L8 30 L8 38 L16 44 Z",
    fill: "#4A5A82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 44,
    width: 14,
    height: 6,
    rx: 1,
    fill: "#C9A227"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 26,
    r: 12,
    fill: "#1A2A52"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 31,
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fontWeight: "bold",
    fill: "#C9A227",
    textAnchor: "middle"
  }, "$")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 44,
    r: 10,
    fill: "#C9A227"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 49,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: "bold",
    fill: "#1A2A52",
    textAnchor: "middle"
  }, "&#8377;")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyCommodity);
export default __webpack_public_path__ + "static/media/currency-commodity.186d43672af2070484c94cd82b6184df.svg";
export { ForwardRef as ReactComponent };